module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "top-nav-container"
  }, [_c('nav', {
    staticClass: "top-nav"
  }, [_c('router-link', {
    staticClass: "vertical-center nav-logo",
    attrs: {
      "to": "/source"
    }
  }, [_c('img', {
    staticClass: "logo vertical-center-content",
    attrs: {
      "src": require("../../assets/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "brand vertical-center-content"
  }, [_vm._v("Leetcode Solutions")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav-link-container"
  }, [_c('li', {
    staticClass: "nav-link-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/cover"
    }
  }, [_vm._v(_vm._s(_vm.language === 'en' ? "Guide" : "介绍"))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-link-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/source"
    }
  }, [_vm._v(_vm._s(_vm.language === 'en' ? "Source Code" : "源码"))])], 1), _vm._v(" "), (_vm.gitRepoUrl !== null) ? _c('li', {
    staticClass: "nav-link-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": _vm.gitRepoUrl
    }
  }, [_c('img', {
    staticClass: "github-logo",
    attrs: {
      "src": require("../../assets/github.jpeg")
    }
  }), _vm._v("git repos")])]) : _vm._e()]), _vm._v(" "), _c('img', {
    staticClass: "menu-button",
    attrs: {
      "src": require("../../assets/menu.png"),
      "alt": ""
    },
    on: {
      "click": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-container top"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    staticClass: "search",
    class: [_vm.inputing ? 'active' : ''],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchResult.length > 0 && _vm.inputing),
      expression: "searchResult.length > 0 && inputing"
    }],
    staticClass: "result-list"
  }, _vm._l((_vm.searchResult), function(result) {
    return _c('li', {
      staticClass: "result-item"
    }, [_c('router-link', {
      attrs: {
        "to": '/source/' + result.id
      }
    }, [_vm._v(_vm._s(result.id) + " . " + _vm._s(result.title))])], 1)
  }))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-3f0aeec6!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/HeaderNav.vue
// module id = 75
// module chunks = 2